import {
   OMNI_2100_VALVE_PUMP_ROWS,
   OMNI_30XX_VALVE_PUMP_ROWS,
   VALVE_PUMP_HEADERS,
   ValvePumpRow,
   savedValvePumpValues,
} from '../modals/config-modal/model/valve-pump-row';
import { OMNI_22XX_MODAL_TYPE, OMNI_30XX_MODAL_TYPE } from './sensor-type-names';

/**
 * Rows of the read-only configuration views (Configure page and the live-page Configuration
 * View). Built fresh for every config emission, so live updates never stack rows.
 */

const OMNI_2000_MODAL_TYPE = 1;
const T_HEADERS = ['tIdle', 'tTarget', 't1', 't2', 't3'];

// Frac Delta, Absolute, Delta
const BASE_T_ROWS = [
   ['KP1', 'KP3', 'PCF', 'Injector', 'Column1', 'Column2', 'Column3'],
   ['KP1', 'KP2', 'KP3', 'KP4', 'PCF', 'Injector', 'Column1', 'Column2', 'Column3'],
   ['KP1', 'KP3', 'PCF', 'Injector', 'Column1', 'Column2', 'Column3'],
];

const tRowsFor = (rows: string[], modalType: number): string[] => {
   switch (modalType) {
      case OMNI_2000_MODAL_TYPE:
         return rows.filter(row => !['KP3', 'Injector'].includes(row));
      case OMNI_22XX_MODAL_TYPE:
         return [...rows.filter(row => !['KP1', 'KP2', 'KP3', 'Injector'].includes(row)), 'NafionTube'];
      case OMNI_30XX_MODAL_TYPE:
         // Omni-30xx drives the Injector, so it stays; PID replaces NafionTube.
         return [...rows.filter(row => !['KP1', 'KP2', 'KP3'].includes(row)), 'PID', 'Target_Board_Temp'];
      default:
         return [...rows];
   }
};

export const viewTKeyTables = (modalType: number) =>
   BASE_T_ROWS.map(rows => ({ headers: [...T_HEADERS], rows: tRowsFor(rows, modalType) }));

export const viewValvePumpKeyTable = (modalType: number) => ({
   headers: VALVE_PUMP_HEADERS,
   rows: modalType === OMNI_30XX_MODAL_TYPE ? OMNI_30XX_VALVE_PUMP_ROWS : OMNI_2100_VALVE_PUMP_ROWS,
});

export const tRowLabel = (row: string): string => (row === 'Target_Board_Temp' ? 'Target board temp (°C)' : row);

/** Cell text as the views have always shown it: the saved value, or N/A when the row is missing. */
export const valvePumpCellText = (step: any, row: ValvePumpRow, header: string) => {
   const saved = savedValvePumpValues(step, row);
   return saved ? saved[header] : 'N/A';
};
